import { render, staticRenderFns } from "./RelatedProducts.vue?vue&type=template&id=3d677b62"
import script from "./RelatedProducts.vue?vue&type=script&lang=ts"
export * from "./RelatedProducts.vue?vue&type=script&lang=ts"
import style0 from "./RelatedProducts.vue?vue&type=style&index=0&id=3d677b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports